import { motion,useAnimation, useInView } from "framer-motion"
import { useEffect, useRef } from "react"

export const Reveal = ({children, widthClass, revealSecondDiv }) =>{
    const ref = useRef(null)
    const isInView = useInView(ref,{once: true})
    const mainControls = useAnimation()
    const slideControls = useAnimation()

    useEffect(()=>{
if(isInView){
    mainControls.start("visible")
    slideControls.start("visible")
}else{
    mainControls.start("hidden")
    slideControls.start("hidden")
}
    },[isInView,mainControls,slideControls])

    return(
        <div ref={ref} className={`position-relative overflow-hidden ${widthClass}`}>
            <motion.div
            variants={{
                hidden: {opacity: 0, x: -25},
                visible: {opacity: 1, x:0}
            }}
            initial="hidden"
            animate={mainControls}
            transition={{duration: 0.5, delay: 0.25}}
            >{children}</motion.div>
            {revealSecondDiv && (
        <motion.div
          variants={{
            hidden: { left: 0 },
            visible: { left: '100%' }
          }}
          initial="hidden"
          transition={{ duration: 0.5, ease: "easeIn" }}
          animate={slideControls}
          style={{
            position: "absolute",
            top: 4,
            bottom: 4,
            left: 0,
            right: 0,
            background: "#f2f2f2",
            zIndex: 20
          }}
        />
      )}
         
        </div>
    )

}